/* @flow */

import * as React from 'react';
import { compose, withProps } from 'recompose';
import glamorous, { withTheme } from 'glamorous';

type Props = {
  breakpoint: number,
  desktopImage: string,
  mobileImage: string,
};

const Image = glamorous.img({
  height: 'auto',
  width: '100%',
});

const Picture = glamorous.picture({
  height: 'auto',
  width: '100%',
});

function ResponsiveBanner({
  breakpoint,
  desktopImage,
  mobileImage,
}: Props) {
  return (
    <Picture>
      <source media={`(max-width: ${breakpoint}px)`} srcSet={mobileImage} />
      <source media={`(min-width: ${breakpoint + 1}px)`} srcSet={desktopImage} />
      <Image src={mobileImage} alt="" />
    </Picture>
  );
}

const enhancer = compose(
  withTheme,
  withProps(({ theme }) => ({
    breakpoint: theme.breakpointNumeric.tabletLandscape,
  })),
);

export default enhancer(ResponsiveBanner);
